<template>
  <div v-if="loaded" id="app" class="maindiv">
    <router-view v-wechat-title="title"/>
  </div>
</template>

<script>
import utils from '@/js/utils'

export default {
  components: {
  },
  data() {
    return {
      loaded: false,
      title: '',
      
    }
  },
  computed: {
  },
  created() {
    window.ceshiId = this.getQueryString("id", 0);
    window.qudao = this.getQueryString("qudao", "0");
    window.fromid = this.getQueryString("fromid", 0);
    window.unionid = '';
    if (utils.isWeixin() == false) {
      let unionid = localStorage.getItem('unionid');
      if (!unionid) {
        unionid = "mku" + utils.createIdcode();
        localStorage.setItem('unionid', unionid);
      }
      window.unionid = unionid;
    }

    if (ceshiId == 30) {
      let url = `http://mkstatic.yixinli.xin/h5app/universe/index.html?id=${ceshiId}&qudao=${qudao}&fromid=${fromid}`;
      location.href = url;
      return;
    }

    // this.checkLogin();
    this.getWechatData();
    this.getCeshi();

    let hfs = parseFloat(document.documentElement.style.fontSize.replace('px', ''));
    window.pxbase = 75 / hfs;
  },
  mounted() {
    let that = this;
    document.addEventListener("WeixinJSBridgeReady", function() {
      console.log("WeixinJSBridgeReady");
      that.handleFontSize();
      that.playBgAudio();
    });
  },
  methods: {
    handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function() {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
        });
    },
    codeShowChange(val) {
      this.codeShow = val;
    },
    // checkLogin() {
    //   let url = this.$apis.checklogin + `?wxmp=${window.wxmp}`;
    //   this.$axios.get(url).then(res => {
    //     if (res.data.errcode == 0) {
    //       window.user = res.data.data;
    //       window.unionid = window.user.unionid;
    //       this.setUser(user);
    //     }
    //   });
    // },
    getCeshi() {
      let keyid = `ceshi:cmapp:${window.ceshiId}`;
      let userid = localStorage.getItem(keyid) || 0;
      let url = this.$apis.ceshi + `?wxmp=${window.wxmp}&id=${window.ceshiId}&qudao=${window.qudao}&fromid=${window.fromid}&userid=${userid}&unionid=${window.unionid}`;
      this.$axios.get(url).then((res) => {
          if (res.data.errcode == 0) {
            let Data = res.data.data;
            let ceshi = Data.ceshi;
            this.setCeshi(Data.ceshi);
            this.setUser(Data.user);
            this.title = ceshi.title;

            this.initBgAudio();
            this.playBgAudio();

            localStorage.setItem(keyid, Data.user.id);
            window.unionid = Data.user.unionid;

            this.loaded = true;

            let h5url = location.href;
            this.initWx({
                title: ceshi.title,
                desc: ceshi.brief,
                link: h5url,
                imgUrl: ceshi.subimg,
            })
          }
      });
    },
  }
};
</script>


<style lang="scss">
@import "@/scss/common.scss";
@import "@/scss/animate.scss";
@import "@/scss/function.scss";
html {
  background-color: #f9fafe;
}
.layui-layer-btn {
  font-size: px2rem(28);
}
.maindiv {
  // height: 100%;
  width: px2rem(750);
  height: 100vh;
  margin: auto;
}
.pageblock {
    padding-left: px2rem(30);
    padding-right: px2rem(30);
}
.pageblock-item {
    position: relative;
    background: #FFFFFF;
    box-shadow: 0 px2rem(14) px2rem(20) 0 #EEEFF7;
    border-radius: px2rem(12);
    width: px2rem(690);
    margin-top: px2rem(30);
}
</style>
<style lang="scss" scoped>
@import "@/scss/function.scss";
#app {
  font-size: px2rem(28);
  // height: 100%;
  // position: fixed;
  // width: 100%;
  // left: 0;
  // top: 0;
  // overflow: scroll;
}
.headcover {
  width: px2rem(750);
  height: px2rem(500);
  background-image: url("https://appimg.onexinli.com/marketing/20191213/k43j4qz3.jpg");
  background-size: px2rem(750) px2rem(500);
}
.tabpage {
  padding-bottom: px2rem(100);
}
</style>
